import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Sl No.",
    id: "siNo",
  },
  {
    label: "Plant",
    id: "plant",
  },
  {
    label: "List No.",
    id: "listNo",
  },
  {
    label: "Cut-in Number",
    id: "engineCutInNumber",
  },
  {
    label: "Cut-in Date",
    id: "cutInDate",
    render: (data) => (
      <span>
        {data?.cutInDate && moment(data.cutInDate).format("DD/MM/YYYY")}
      </span>
    ),
  },
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Engine Model",
    id: "engineModel",
  },
  {
    label: "Defect",
    id: "defectCode",
    render: (data) => {
      return `${data?.defectCode?.code}-${data?.defectCode?.description}`;
    },
  },
  {
    label: "Complaint",
    id: "complaint",
  },

  {
    label: "Actions Taken",
    id: "action",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("DOWNLOAD", data)}>
          <Icon
            icon="tabler:download"
            width="1.5rem"
            height="1.5rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton>
          <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
        </IconButton>
      </Box>
    ),
  },
];
export const getInternalCutInFormConfig = (
  oemsList = [],
  defectCodeList = []
) => [
  {
    name: "plant",
    type: "text",
    label: "Plant",
    placeholder: "Enter Plant",
    required: true,
  },

  {
    name: "listNo",
    type: "text",
    label: "List No.",
    placeholder: "Enter List No.",
    required: true,
  },
  {
    name: "engineCutInNumber",
    type: "text",
    label: "Engine Cut-in Number",
    placeholder: "Enter Engine Cut-in Number",
    required: true,
  },
  {
    name: "defectCode",
    type: "autocomplete",
    options: defectCodeList,
    label: "Defect Code",
    placeholder: "Select Defect",
    required: true,
  },
  {
    name: "cutInDate",
    type: "datePicker",
    label: "Cut-in Date",
    placeholder: "Cut-in Date",
    required: true,
  },
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Org",
    options: oemsList,
    placeholder: "Select Oem",
    required: true,
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Enter Engine Model",
    required: true,
  },
  {
    name: "complaint",
    type: "text",
    label: "Complaint",
    placeholder: "Enter Complaint",
    required: true,
  },
  {
    name: "action",
    type: "textarea",
    label: "Action",
    placeholder: "Describe Action",
    required: true,
    fieldGridSize: 12,
  },
];
